/**************************************************
 * Nombre:       Login
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import './login.css'
import fondo from '../Recursos/fondo_login.svg'
import {FONDOCARD} from "../Constantes";
import Ingreso from "./Componentes/Ingreso";
import {useEffect, useState} from "react";
import Footer from "./Footer";
import {obtenerIDReferido} from "../CodigoCliente/Funciones/obtenerIDReferido";

const Login = ({logo, setCodigo, setHash}) => {
    const [llega, setLlega] = useState('');

    useEffect(() => {
        let id = obtenerIDReferido('id')

        if (id) {
            setLlega(id)
        }

    }, []);
    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            size={12}
            sx={{
                backgroundImage: `url(${fondo})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, minHeight: '100vh'}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'center'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{py: 4}}
                            >

                                <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                                    <img src={logo} width={112} height={'auto'}/>
                                </Grid>

                                <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end'}}>
                                    <Button variant={'outlined'}
                                            sx={{color: '#fff'}}>Soporte</Button>
                                </Grid>

                            </Grid>
                        </Grid>

                    </Grid>


                </Grid>

                <Grid container size={{xs: 12, sm: 7, md: 4}} sx={{justifyContent: 'center', mt: -8}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems="center"
                        size={12}
                        sx={{
                            ...FONDOCARD,
                            px: 3,
                            py: 3
                        }}
                    >
                        <Ingreso setCodigo={setCodigo} llega={llega}/>

                    </Grid>
                </Grid>


            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}>

                <Footer/>

            </Grid>


        </Grid>
    )

}
export default Login    